import Content from '../components/Content';
import ServiceList from '../components/ServiceList';
import { OPENINGS } from '../data/Careers';
import './Careers.scss';

const Careers = () => {

    return (
        <section className='careers-page'>
            <Content 
                heading='Join the Collective'
                variation='inverse'
            >
                <p>We exist so non-profits, mission-driven organizations, and social-impact businesses can put their mission first. Making Biscuits Co is a group of talented product managers, engineers, designers, and analysts looking to share their talents to make an impact on the world. We offer sliding-scale solutions for all our clients, removing the barrier to accessing high quality tech solutions.</p>
                <p>Our collective has a communal approach to work, and we function similarly to a co-op: we split profits and proceeds evenly amongst ourselves. This allows us to center our mission and as well as center our client experience, crafting professional and intuitive user experiences and products to create a lasting impact.</p>
                <p>Want to join our mission? Submit an application to one of the open positions below.</p>
            </Content>
            <Content>
                <ServiceList
                    serviceItems={OPENINGS} 
                />
            </Content>
        </section>
    )
}

export default Careers;